









































/** Причина блокировки приходит готовым ключом перевода, null означает «создавать можно» */
import { Component, Prop, Vue } from 'vue-property-decorator';

import MmHintedButton from '../../../components/MmHintedButton.vue';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.taskForm.';

@Component({
	components: { MmHintedButton },
})
export default class CreateFooter extends Vue {
	@Prop({ default: null }) readonly blockReasonKey!: string | null;

	@Prop({ default: 0 }) readonly selectedCount!: number;

	@Prop({ default: false }) readonly showSelectedCount!: boolean;

	@Prop({ default: null }) readonly estimateCount!: number | null;

	@Prop({ default: false }) readonly submitting!: boolean;

	get isBlocked(): boolean {
		return this.blockReasonKey !== null && this.blockReasonKey !== '';
	}

	/** loading у ant не ставит disabled, гасим кнопку сами: второе нажатие создаст вторую пачку */
	get isSubmitDisabled(): boolean {
		return this.isBlocked || this.submitting;
	}

	get disabledReasonText(): string {
		const key = this.blockReasonKey;

		if (key !== null && key !== '') {
			return this.$t(key) as string;
		}

		if (this.submitting) {
			return this.busyReasonText;
		}

		return '';
	}

	get busyReasonText(): string {
		return this.$t(KEY_PREFIX + 'blockSubmitting') as string;
	}

	get submitText(): string {
		if (this.showSelectedCount && this.selectedCount > 0) {
			return this.$t(KEY_PREFIX + 'submitWithCount', { count: this.selectedCount }) as string;
		}

		return this.$t(KEY_PREFIX + 'submit') as string;
	}

	get cancelText(): string {
		return this.$t('shared.actions.cancel') as string;
	}

	get selectedText(): string {
		return this.$t(KEY_PREFIX + 'selectedProducts', { count: this.selectedCount }) as string;
	}

	get hasEstimate(): boolean {
		return this.estimateCount !== null;
	}

	get estimateText(): string {
		const count = this.estimateCount !== null ? this.estimateCount : 0;

		return this.$t(KEY_PREFIX + 'estimate', { count }) as string;
	}

	get estimateHintText(): string {
		return this.$t(KEY_PREFIX + 'estimateHint') as string;
	}

	handleSubmit(): void {
		if (this.isSubmitDisabled) {
			return;
		}

		this.$emit('submit');
	}

	handleReset(): void {
		if (this.submitting) {
			return;
		}

		this.$emit('reset');
	}
}
